module.exports = __webpack_public_path__ + "img/nav-right-with-contact-black-hyundai.ea3e261d.png";